import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  TRANSLOCO_SCOPE,
  TranslocoModule,
  TranslocoService,
} from '@jsverse/transloco';
import { QaiFloatingSelectComponent } from '@qai/ui';
import { AssignmentCategory } from 'src/app/interfaces/reportingV2/ipractice-assignment-stats-request';
import { ReportingLocalStorageUtil } from 'src/app/utils/reporting-localstorage.util';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';

@Component({
  selector: 'app-assignment-filter',
  templateUrl: './assignment-filter.component.html',
  styleUrls: ['./assignment-filter.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'reportingV2',
    },
  ],
  imports: [CommonModule, TranslocoModule, QaiFloatingSelectComponent],
})
export class AssignmentFilterComponent {
  @Input() assignmentType: 'practice' | 'certification' = 'practice';
  @Output() assignmentTypeChange = new EventEmitter<AssignmentCategory>();
  assignmentOptions: { label: string; value: string }[] = [];
  selectedAssignmentType: AssignmentCategory = 'RECENT_ASSIGNMENTS';

  constructor(
    private translocoService: TranslocoService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    // Initialize options
    this.assignmentOptions = [
      {
        label: this.translocoService.translate(
          'ALL_ASSIGNMENTS',
          {},
          'reportingV2'
        ),
        value: 'ALL_ASSIGNMENTS' as AssignmentCategory,
      },
      {
        label: this.translocoService.translate(
          'RECENT_ASSIGNMENTS',
          {},
          'reportingV2'
        ),
        value: 'RECENT_ASSIGNMENTS' as AssignmentCategory,
      },
    ];

    // Load stored value or use default
    let storedFilter;
    if (this.assignmentType === 'practice') {
      storedFilter =
        ReportingLocalStorageUtil.getStoredPracticeAssignmentFilter();
    } else if (this.assignmentType === 'certification') {
      storedFilter =
        ReportingLocalStorageUtil.getStoredCertificationAssignmentFilter();
    }

    this.selectedAssignmentType =
      (storedFilter as AssignmentCategory) || 'RECENT_ASSIGNMENTS';

    if (!storedFilter) {
      if (this.assignmentType === 'practice') {
        ReportingLocalStorageUtil.setStoredPracticeAssignmentFilter(
          'RECENT_ASSIGNMENTS',
        );
      } else if (this.assignmentType === 'certification') {
        ReportingLocalStorageUtil.setStoredCertificationAssignmentFilter(
          'RECENT_ASSIGNMENTS',
        );
      }
    }

    // Emit initial value
    this.assignmentTypeChange.emit(this.selectedAssignmentType);
  }

  onAssignmentChange(event: string): void {
    
    // Track assignment filter click
    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.REPORTINGDASHBOARD_CLICK_ASSIGNMENTFILTER);
    this.selectedAssignmentType = event as AssignmentCategory;

    if (this.assignmentType === 'practice') {
      ReportingLocalStorageUtil.setStoredPracticeAssignmentFilter(event);
    } else if (this.assignmentType === 'certification') {
      ReportingLocalStorageUtil.setStoredCertificationAssignmentFilter(event);
    }
    // Emit the updated value
    this.assignmentTypeChange.emit(event as AssignmentCategory);
  }
}
